<template>
  	<div id="page-content-wrapper" class="admin-content-area cl">
    	<div class="container-fluid xyz location-listing">
      		<div class="page-header-top-container" style="position: fixed;">
                <div class="page-name">Audit Inventory Detail List</div>
                <button type="submit" v-on:click.prevent="loadDetailCustomerAuditInventory(true)" class="btn btn-primary waves-effect pull-right">Export</button>
                <button type="submit" v-on:click.prevent="backAuditInventory()" class="btn btn-primary waves-effect pull-right">Back</button>
                <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadDetailCustomerAuditInventory(false)">
                    <i class="fa fa-rotate-right" aria-hidden="true"></i>
                </button>
            </div>

            <div class="admin-page-content" style="padding-top: 80px;">
                <!-- <label class="policy-text">** Total displayed below does not include Tax and Core Charges</label> -->
                <div class="contact-grid-container">
                    <div class="row no-margin">
                        <div class="app-filter-good-table-container text-align-placeholder-user-admin-customer-detail-audit-inventory-list">
                            <vue-good-table
                                ref="listCustomerAuditInventory"
                                mode="remote"
                                title="Customer Audit Inventory"
                                @on-page-change="onPageChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'pages',
                                    pageLabel: 'Page',
                                    position: 'both',
                                    perPage: serverParams.perPage,
                                    setCurrentPage: serverParams.setCurrentPage,
                                    perPageDropdown: [25, 50, 100, 200 ,500],
                                    dropdownAllowAll: false,
                                }"
                                :search-options="{
                                    enabled: false,
                                }">

                                <!-- Custome Pagination -->
                                <template slot="pagination-top" slot-scope="props">
                                    <div class="vgt-wrap__footer top-pagination crm">
                                        <div  class="row">
                                            <div class="col-sm-12 col-md-2 PerPage">
                                                <v-select title="Select Per Page"
                                                    v-model="serverParams.perPage"
                                                    @change="changedValueTask"
                                                    @input="changedValueTaskCustomPerPageTask()"
                                                    name="customPerPage"
                                                    id="customPerPage"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="serverParams.perPageDropdown"
                                                    placeholder="Select Per Page">
                                                </v-select>
                                            </div>
                                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                            </div>
                                            <div class="col-sm-12 col-md-6 Pagination">
                                                <ul class="pagination">
                                                    <li class="FirstPage" title="First Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                    </li>
                                                    <li class="page-item PreviousPage" title="Previous Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                    </li>
                                                    <!--New Implementation-->
                                                    <template v-if="pageNumberListTask() < displayPageTask">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <!--End New Implementation-->
                                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                            <template v-for="(n, index) in displayPageTask">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                            <template v-for="(n, index) in pageNumberListTask()">
                                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <li class="page-item NextPage" title="Next Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                    </li>
                                                    <li class="LastPage" title="Last Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <p class="pageJumpLabel">Page : </p>
                                            </div>
                                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- End Custome Pagination -->

                                <!-- Custome Pagination -->
                                <template slot="pagination-bottom" slot-scope="props">
                                    <div class="vgt-wrap__footer crm">
                                        <div  class="row">
                                            <div class="col-sm-12 col-md-2 PerPage">
                                                <v-select title="Select Per Page"
                                                        v-model="serverParams.perPage"
                                                        @change="changedValueTask"
                                                        @input="changedValueTaskCustomPerPageTask()"
                                                        name="customPerPage"
                                                        id="customPerPage"
                                                        label="text"
                                                        :clearable="false"
                                                        :searchable="false"
                                                        :filterable="false"
                                                        :options="serverParams.perPageDropdown"
                                                        placeholder="Select Per Page">
                                                </v-select>
                                            </div>
                                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                            </div>
                                            <div class="col-sm-12 col-md-6 Pagination">
                                                <ul class="pagination">
                                                    <li class="FirstPage" title="First Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                    </li>
                                                    <li class="page-item PreviousPage" title="Previous Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                    </li>
                                                    <!--New Implementation-->
                                                    <template v-if="pageNumberListTask() < displayPageTask">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <!--End New Implementation-->
                                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                            <template v-for="(n, index) in displayPageTask">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                            <template v-for="(n, index) in pageNumberListTask()">
                                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <li class="page-item NextPage" title="Next Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                    </li>
                                                    <li class="LastPage" title="Last Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <p class="pageJumpLabel">Page : </p>
                                            </div>
                                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- End Custome Pagination -->

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                        </div>
                                        <div v-else>{{props.formattedRow[props.column.field]}}</div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions" slot-scope="computed">
                                    {{computed.selectedRows}}
                                </div>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <customer-footer></customer-footer>
    </div>
</template>

<script>
    var self;
    import Vue from "vue";
    import CustomerFooter from "@/components/partials/CustomerFooter";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';

    Vue.use(VueGoodTable);
    export default {
        name: "CustomerDateWiseAuditInventoryList",
        components: {
            'customer-footer': CustomerFooter,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                customerName: "",
                roleId: 0,
                firstLoad: 0,
                columns: [
                    {
                        label: "User Name",
                        field: "user_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: "Customer Name",
                        field: "customer_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    /* {
                        label: "Inventory",
                        field: "inventory_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Inventory", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Part Name",
                        field: "part_no",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Part Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Description",
                        field: "part_description",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Description", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: "Max Qty",
                        field: "max_qty",
                        type: "number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Max Qty", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "QOH",
                        field: "qoh",
                        type: "number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "QOH", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Audit Qty",
                        field: "used_qty",
                        type: "number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Audit Qty", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Bin Location",
                        field: "bin_location",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Bin Location", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Date",
                        field: "created_at", //"updated_at"
                        filterable: false,
                        sortable: false,
                        /* filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: "Audit Completion Date",
                        field: "audit_close_date_time",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Deleted By",
                        field: "deleted_by",
                        /* filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Deleted By", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                        sortable: false,
                    },
                    /* {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    } */
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                loginUserId : 0,
                customerId: 0,
            };
        },
        beforeMount: function() {
            self = this;
        },
        mounted: function() {
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 300);
            });
            self.customerProtal();
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            if(localStorage.getItem("login_role") == 'user') {
                self.customerId = localStorage.getItem("customer_id");
                self.loadDetailCustomerAuditInventory(false);
            } else {
                var customerObj = localStorage.getItem("customer_obj");
                //if user logged in than remove login button and registration button
                if (customerObj != null) {
                    var customerJson = JSON.parse(customerObj);
                    self.customerId = customerJson['id'];
                    self.loadDetailCustomerAuditInventory(false);
                }
            }

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 310);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.cl .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
        },
        methods: {
            backAuditInventory: function() {
                self.$router.push("/customer/audit/inventory");
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadDetailCustomerAuditInventory(false);
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadDetailCustomerAuditInventory(false);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadDetailCustomerAuditInventory(false);
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadDetailCustomerAuditInventory(false);
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "user_name";
                    field: "customer_name";
                    field: "inventory_name";
                    field: "qty";
                    // field: "updated_at";
                    field: "created_at";
                    field: "deleted_by";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.user_name ||
                    filters.customer_name ||
                    filters.inventory_name ||
                    filters.qty ||
                    // filters.updated_at ||
                    filters.created_at ||
                    filters.deleted_by
                ) {
                    self.loadDetailCustomerAuditInventory(false);
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listCustomerAuditInventory"].selectedRows.length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadDetailCustomerAuditInventory(false);
            },
            loadDetailCustomerAuditInventory: function(isExport) {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        isExport: isExport,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort,
                        tz: moment.tz.guess(),
                        customer_id: self.customerId,
                        audit_date: localStorage.getItem("audit-customer-date"),
                        audit_id: localStorage.getItem("audit-customer-id")
                    }
                };
                HTTP.get("/customer/detail/audit/inventory/list", config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            if(response.data.message == "success export") {
                            	location.href = response.data.content;
                          	} else {
                                if(response.data.content.row && response.data.content.row.length > 0) {
                                    self.customerName = response.data.content.row[0].customer_name;
                                }
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                        }
                    })
                    .catch(function(err) {
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };
    EventBus.$on("change-customer-dropdown-value", function(data) {
        if (typeof self != "undefined") {
            self.customerId = localStorage.getItem("customer_id");
            self.loadDetailCustomerAuditInventory(false);
            
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/Customer/CustomerDateWiseAuditInventoryList.vue